import { useState } from 'react';

export default function Faq({ items }) {
  const [open, setOpen] = useState(null);
  return (
    <div className="faq">
      {items.map((it, i) => {
        const isOpen = open === i;
        return (
          <div className={`faq-item ${isOpen ? 'open' : ''}`} key={i}>
            <button className="faq-q" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen}>
              <span>{it.q}</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d={isOpen ? 'M5 12h14' : 'M12 5v14M5 12h14'} />
              </svg>
            </button>
            <div className="faq-a" style={{ maxHeight: isOpen ? 400 : 0 }}>
              <p>{it.a}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
